import React from 'react'
import Topbar from '../Header/Topbar'
import MainNavbar from '../Header/MainNavbar'
const Events = () => {
  return (
    <>
        <h1>Events</h1>
    </>
  )
}

export default Events